/* eslint-disable react/no-unused-state */
import React, { PropTypes, Component } from 'react'
import merge from 'lodash/merge'
import TextInput from 'components/Form/components/TextInput'
import Filters from 'components/List/components/Filters'
import constants from 'constants'

const styles = Object.assign(
  {},
  require('./PersonalInfoFilter.scss'),
)

class PersonalInfoFilter extends Component {
  static propTypes = {
    filteredPersonalInfos: PropTypes.instanceOf(Array),
    onChangeFilteredPersonalInfos: PropTypes.func,
    onCodeSearchTrigger: PropTypes.func,
    onInitFilteredPersonalInfo: PropTypes.func,
    onLocationSearchTrigger: PropTypes.func,
    onTextSearchTrigger: PropTypes.func,
    personalinfos: PropTypes.object,
    selectedStatusFilter: PropTypes.func,
    setCodeFilter: PropTypes.func,
    setLocationFilter: PropTypes.func,
    setStatusFilter: PropTypes.func,
  }

  static defaultProps = {
    filteredPersonalInfos: [],
    onChangeFilteredPersonalInfos: null,
    onCodeSearchTrigger: null,
    onInitFilteredPersonalInfo: null,
    onLocationSearchTrigger: null,
    onTextSearchTrigger: null,
    personalinfos: null,
    selectedStatusFilter: null,
    setCodeFilter: null,
    setLocationFilter: null,
    setStatusFilter: null,
  }

  constructor(props) {
    super(props)
    // this.handleInitFilteredPersonalInfo = this.handleInitFilteredPersonalInfo.bind(this);
    // this.handleChangeFilteredPersonalInfos = this.handleChangeFilteredPersonalInfos.bind(this);
    this.data = []
    this.state = {
      statusId: '1',
      statusName: 'Active',
      locationId: '',
      locationName: '',
      codeId: '',
      codeName: '',
      search: '',
      typing: false,
      typingTimeout: 0,
      filters: {
        status: null,
        location: null,
        code: null,
      },
      filterData: {
        status: constants.LIST_FILTERS.STATUS,
        location: constants.LIST_DYNAMICFILTERS(constants.ADMINCENTRE.SEARCHFILTER.LOCATION, this.props.personalinfos.locations),
        code: constants.LIST_DYNAMICFILTERS(constants.ADMINCENTRE.SEARCHFILTER.CODE, this.props.personalinfos.codes),
      },
    }
  }

  componentDidMount() {
    const filters = this.state.filters
    let filterSelection = ''

    if (sessionStorage.getItem('AdminCentreFilterSelection')) {
      filterSelection = JSON.parse(sessionStorage.getItem('AdminCentreFilterSelection'))
      if (filterSelection.location) {
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({ locationId: filterSelection.location, locationName: filterSelection.location })
        // setTimeout(() => { this.setState({ locationId: filterSelection.location, locationName: filterSelection.location }) }, 800)
      }
      if (filterSelection.code) {
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({ codeId: filterSelection.code, codeName: filterSelection.code })
        // setTimeout(() => { this.setState({ locationId: filterSelection.location, locationName: filterSelection.location }) }, 800)
      }      
      if (filterSelection.name) {        
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({ search: filterSelection.name })
      }
      this.filterPersonalInfos(filterSelection.location, filterSelection.code, filterSelection.name)
    }

    const newFilters = merge({}, filters, {
      status: (this.props.personalinfos.selectedStatusFilter === 1 ? 'Active' : 'Inactive'),
      location: (filterSelection ? filterSelection.location : ''),
      code: (filterSelection ? filterSelection.code : ''),
    })

    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({ filters: newFilters })
  }

  componentWillReceiveProps(nextProps) {
    const { id, filteredPersonalInfos } = this.props
    this.data = filteredPersonalInfos
    if (nextProps.filteredPersonalInfos !== this.props.filteredPersonalInfos) {
      this.data = nextProps.filteredPersonalInfos
    }
  }

  _handleFocus = (name) => {
    // Create state value obj
    const stateValue = {
      field: name,
      data: {
        focus: true,
      },
    }
    // not in used the component needs this function to not to throw warnings
  }

  _handleChange = (name, value) => {
    // Create state value obj
    const stateValue = {
      field: name,
      data: {
        value,
        error: '',
        valid: true,
      },
    }

    const self = this

    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout)
    }

    self.setState({
      search: stateValue.data.value,
      typing: false,
      typingTimeout: setTimeout(() => {
        self.filterPersonalInfos(self.state.locationName, self.state.codeName, self.state.search)
        this.updateFilterSessionObject(constants.ADMINCENTRE.SEARCHFILTER.NAME, stateValue.data.value)
      }, 2000),
    })

    this.setState({ search: stateValue.data.value })
  }

  _handleValidation = (name) => {
    const stateValue = {
      field: name,
      data: {
        focus: false,
      },
    }
    // not in used the component needs this function to not to throw warnings
  }

  filterByLocation = (data, filtervalue) => {
    this.props.onLocationSearchTrigger(true)
    this.updateFilterSessionObject(constants.ADMINCENTRE.SEARCHFILTER.LOCATION, filtervalue)
    // eslint-disable-next-line eqeqeq
    return data.filter(item => item.location == filtervalue)
  }

  filterByCode = (data, filtervalue) => {
    this.props.onCodeSearchTrigger(true)
    this.updateFilterSessionObject(constants.ADMINCENTRE.SEARCHFILTER.CODE, filtervalue)
    // eslint-disable-next-line eqeqeq
    return data.filter(item => item.code == filtervalue)
  }

  filterByName = (data, filtervalue) => {
    if (filtervalue) {
      this.updateFilterSessionObject(constants.ADMINCENTRE.SEARCHFILTER.NAME, filtervalue)
      return data.filter(item => (item.name.toLowerCase().includes(filtervalue.toLowerCase().trim())
    || item.id.toLowerCase().includes(filtervalue.toLowerCase().trim())
    || item.email.toLowerCase().includes(filtervalue.toLowerCase().trim())
      ))
    }
    return data
  }

  filterPersonalInfos = (location, code, partnername) => {
    let filteredinfo = [...new Set(this.props.personalinfos.personalinfos)]
    if (location) {
      filteredinfo = this.filterByLocation(filteredinfo, location)
    }
    if (code) {
      filteredinfo = this.filterByCode(filteredinfo, code)
    }
    if (partnername) {
      filteredinfo = this.filterByName(filteredinfo, partnername)
      this.props.onTextSearchTrigger(true)
    } else {
      this.props.onTextSearchTrigger(false)
    }
    this.props.onChangeFilteredPersonalInfos(filteredinfo)
  }

  updateFilterSessionObject = (filterBy, filterValue) => {
    let filterSelection = {
      name: '',
      location: '',
      code: '',
    }
    if (sessionStorage.getItem('AdminCentreFilterSelection')) {
      filterSelection = JSON.parse(sessionStorage.getItem('AdminCentreFilterSelection'))
    }
    if (filterBy.toLowerCase() === constants.ADMINCENTRE.SEARCHFILTER.NAME.toLowerCase()) {
      filterSelection.name = filterValue
    }
    if (filterBy.toLowerCase() === constants.ADMINCENTRE.SEARCHFILTER.LOCATION.toLowerCase()) {
      filterSelection.location = filterValue
    }
    if (filterBy.toLowerCase() === constants.ADMINCENTRE.SEARCHFILTER.CODE.toLowerCase()) {
      filterSelection.code = filterValue
    }
    sessionStorage.setItem('AdminCentreFilterSelection', JSON.stringify(filterSelection))
  }

  clearFilters = () => {
    this.setState({
      search: '',
      filters: {
        status: null,
        location: null,
        code: null,
      },
    })
    this.props.setStatusFilter(1)
    this.props.onInitFilteredPersonalInfo()
  }

  filter = ({ type = null, value = null }) => {
    const filters = this.state.filters
    const newFilters = merge({}, filters, {
      [type]: value,
    })

    this.setState({ filters: newFilters }, () => {
      /* TODO: please put your filter logic here */
      if (String(type) === constants.ADMINCENTRE.SEARCHFILTER.STATUS.toLowerCase()) {
        this.setState({ statusId: value, statusName: value })
        // update redux status state
        this.props.setStatusFilter((String(value) === 'Active' ? 1 : 0))
        // init personal info data -- load from database
        this.props.onInitFilteredPersonalInfo()
      } else if (String(type) === constants.ADMINCENTRE.SEARCHFILTER.LOCATION.toLowerCase()) {
        this.setState({ locationId: value, locationName: value })
        // update redux status state
        this.props.setLocationFilter(value)
        this.filterPersonalInfos(value, this.state.codeName, this.state.search)
      } else if (String(type) === constants.ADMINCENTRE.SEARCHFILTER.CODE.toLowerCase()) {
        this.setState({ codeId: value, codeName: value })
        // update redux code state
        this.props.setCodeFilter(value)
        this.filterPersonalInfos(this.state.locationName, value, this.state.search)
      }
    })
  }

  render() {
    return (
      <section className={styles.section}>
        <div className={styles.searchinput}>
          <TextInput
            showSearchIcon
            handleChange={this._handleChange}
            label="Search"
            name="Search"
            onBlur={this._handleValidation}
            onFocus={this._handleFocus}
            text={this.state.search}
          />
        </div>
        {/* <div className={styles.gridcontainerelement}> */}
        <div className={styles.gridfilterelement}>
          <div className={styles.gridchildfilterelement1}>
            <div className={styles.partnertitle}>Partners</div>
            <div className={styles.partnercount}>({(this.state.search || this.state.locationName || this.state.codeName)
            ? this.props.filteredPersonalInfos.length : this.props.personalinfos.numRecords})</div>
          </div>
          <div className={styles.gridchildfilterelement2}>
            <Filters
              clearFilters={this.clearFilters}
              filter={this.filter}
              filterData={this.state.filterData}
              rules={this.state.filters}
            />
          </div>
        </div>
      </section>
    )
  }
}

export default PersonalInfoFilter



// WEBPACK FOOTER //
// ./src/views/AdminCentre/components/PersonalInfoFilter.js